import './DashboardTable.css';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import DashboardTableItem from './DashboardTableItem';
import { SitecoreContextReactContext } from '../../../../utils/SitecoreContextReactContext';
import { getDictionaryItem, get } from '../../../../utils';
import { getSessionId } from '../../../DAcApplication/utils';
import Loader from '../../../DAcApplication/components/loader';
import InjectHTML from '../../../DAcCreateAccount/components/InjectHTML';
import DashboardEmpty from './DashboardEmpty';
const DashboardItems = [{
  ApplicationNo: '23WA23445',
  ApplicantName: {
    EN: 'Juan Dela Cruz Manalo',
    AR: 'Juan Dela Cruz Manalo'
  },
  CreatedDate: '22-11-2024',
  StatusId: 'DRAFT',
  StatusName: {
    EN: 'Test 1',
    AR: 'Test 1 AR'
  }
}, {
  ApplicationNo: '23WA23445',
  ApplicantName: {
    EN: 'Juan Dela Cruz Manalo',
    AR: 'Juan Dela Cruz Manalo'
  },
  CreatedDate: '22-11-2024',
  StatusId: 'PAYMENTINITIATED',
  StatusName: {
    EN: 'Test 2',
    AR: 'Test 2 AR'
  }
}, {
  ApplicationNo: '23WA23445',
  ApplicantName: {
    EN: 'Juan Dela Cruz Manalo',
    AR: 'Juan Dela Cruz Manalo'
  },
  CreatedDate: '22-11-2024',
  StatusId: 'COMPLETE',
  StatusName: {
    EN: 'Test 2',
    AR: 'Test 2 AR'
  }
}, {
  ApplicationNo: '23WA23445',
  ApplicantName: {
    EN: 'Juan Dela Cruz Manalo',
    AR: 'Juan Dela Cruz Manalo'
  },
  CreatedDate: '22-11-2024',
  StatusId: 'REJECTED',
  StatusName: {
    EN: 'Test 3',
    AR: 'Test 3 AR'
  }
}, {
  ApplicationNo: '23WA23445',
  ApplicantName: {
    EN: 'Juan Dela Cruz Manalo',
    AR: 'Juan Dela Cruz Manalo'
  },
  CreatedDate: '22-11-2024',
  StatusId: 'ADDITIONALDOCREQUIRED',
  StatusName: {
    EN: 'Test 4',
    AR: 'Test 4 AR'
  }
}, {
  ApplicationNo: '23WA23445',
  ApplicantName: {
    EN: 'Juan Dela Cruz Manalo',
    AR: 'Juan Dela Cruz Manalo'
  },
  CreatedDate: '22-11-2024',
  StatusId: 'INPROCESS',
  StatusName: {
    EN: 'Test 5',
    AR: 'Test 5 AR'
  }
}, {
  ApplicationNo: '22410101129122',
  ApplicantName: {
    EN: 'Juan Dela Cruz Manalo',
    AR: 'Juan Dela Cruz Manalo'
  },
  CreatedDate: '22-11-2024',
  StatusId: 'APPROVED',
  StatusName: {
    EN: 'Test 6',
    AR: 'Test 6 AR'
  }
}];
const TOKKEN = `Bearer%20eyJhbGciOiJIUzI1NiIsImtpZCI6IkY3QzdERTM0N0FFNEI5OEUyNDQ4NjMyQjk4Qzc0NjQ0M0Y2OUFDMjBEODc0MDU1RjVFMTBDQjRFRTI0QjZDMUQiLCJ0eXAiOiJKV1QifQ.eyJzdWIiOiI4NUQ2NUNENzY2ODMxMzM0RjY0QzZCQTQ0OUNDM0I4OTc2NDkxREI2QjIzRDZENzgwNDQ2RUU5QzBCMTIxNzc4IiwianRpIjoiZUhuVVdWYUY5dy9VdlJWaTc3NGw1eHIzMlZqTmVBSG95aUpiWmduTEdVbmF1MmJxRTE1L1JjSHh1MmlxVThUUjFtMExLNCt1YTB3a0hSZHcyalc1MUEiLCJ1c2VyVHlwZSI6InVzZXIiLCJpc0luZGl2aWR1YWwiOiJUcnVlIiwidXNlclB1YmxpY0lkIjoiM2NiYzg0OTgtODE0Yy00M2QxLWJhMDItZWUyN2IwMTdmNjhjIiwidXNlcm5hbWUiOiJyYXNobWkucmFqcHV0MSIsImVpZGEiOiIiLCJuYmYiOjE3Mzc5NzI0MTEsImV4cCI6MTczODA1ODgxMSwiaWF0IjoxNzM3OTcyNDExLCJpc3MiOiJFOUU2ODg4Q0YzMUZGM0QwQTRGOEM0ODYyOEVDMjg4OTA5MzY0ODIwM0E0N0I1RDZEQTBGMTNFQjAyQjdFNjUwIiwiYXVkIjoiMzRDMEExRjUxNTk2N0UzRjE3NzQ5MDhCN0U4QzU0MzY5Mjk2QTFDQThGNUZDNjRFNDA3RkM4RTJEMDk0NUI5QSJ9.2qk_L9zAQT8gqMWZdEwuEhSIGBi9mARjEVTV-VZcGqg`;
const DashboardTable = props => {
  const {
    dictionary,
    settings,
    configuration,
    getAppStatus
  } = props;
  const DashboardTableHeader = [getDictionaryItem(dictionary, 'applicationNo'), getDictionaryItem(dictionary, 'applicantName'), getDictionaryItem(dictionary, 'createdOn'), getDictionaryItem(dictionary, 'status'), getDictionaryItem(dictionary, 'actions')];
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const sessionId = getSessionId('dashboard');
  const apiKey = get(settings, 'apiKey.jss.value');
  const apiUrl = get(settings, 'apiUrl.jss.value');
  const loginPage = get(settings, 'loginPage.jss.value.href');
  const history = useHistory();
  const [userTokken, setUserTokken] = useState('');
  const [username, setUsername] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [applicationTotalCount, setApplicationTotalCount] = useState(0);
  const [applicationList, setApplicationList] = useState([]);
  const [page, setPage] = useState(1);
  const [authFailed, setAuthFailed] = useState('');
  const searchApplications = async () => {
    setAuthFailed('');
    applicationList.length > 0 ? setIsLoadingMore(true) : setIsLoading(true);
    const url = `${apiUrl}/v1/proxy/inquiry/individual/application/search`;
    const headers = new Headers();
    headers.append('X-Request-Id', sessionId);
    headers.append('Apikey', apiKey);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', userTokken || TOKKEN);
    headers.append('Host', 'dacqa.detsandbox.com');
    headers.append('User-Agent', 'Apidog/1.0.0 (https://apidog.com)');
    const data = {
      ApplicationNo: '',
      pageNumber: page,
      pageSize: 50,
      statusIds: '',
      includeService: '',
      excludeService: ''
    };
    const requestOptions = {
      method: 'POST',
      headers: headers,
      redirect: 'follow',
      keepalive: true,
      withCredentials: true,
      body: JSON.stringify(data)
    };
    await fetch(url, requestOptions).then(response => {
      if (response.status == 401) {
        Cookies.remove('token');
        Cookies.remove('username');
        history.push(loginPage);
        return false;
      }
      return response.json();
    }).then(result => {
      if (result.hasOwnProperty('desc')) {
        setAuthFailed(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
      }
      if (result.hasOwnProperty('ApplicationList')) {
        setApplicationList([...applicationList, ...result.ApplicationList]);
        setApplicationTotalCount(result.TotalCount);
      }
    }).catch(error => {
      console.error('searchApplications error', error);
    }).finally(() => {
      setIsLoading(false);
      setIsLoadingMore(false);
    });
  };
  const [totalApplicants, setTotalApplicants] = useState(0);
  const getUserStatus = async () => {
    const url = `${apiUrl}/v1/orc/user/${username}/status`;
    const headers = new Headers();
    headers.append('X-Request-Id', sessionId);
    headers.append('Apikey', apiKey);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', userTokken || TOKKEN);
    headers.append('Host', 'dacqa.detsandbox.com');
    headers.append('User-Agent', 'Apidog/1.0.0 (https://apidog.com)');
    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
      keepalive: true,
      withCredentials: true
    };
    await fetch(url, requestOptions).then(response => {
      if (response.status == 401) {}
      return response.json();
    }).then(result => {
      if (result.hasOwnProperty('desc')) {
        console.error(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
      }
      if (result.hasOwnProperty('totalApplicants')) {
        setTotalApplicants(result.totalApplicants);
      }
    }).catch(error => {
      console.error('User Status error', error);
    }).finally(() => {
      setIsLoading(false);
      setIsLoadingMore(false);
    });
  };
  const loadMore = () => {
    setPage(prevState => prevState + 1);
  };
  useEffect(() => {
    const tokken = Cookies.get('token');
    const userNameCookie = Cookies.get('username');
    if (userNameCookie) setUsername(userNameCookie);
    if (!tokken) {
      history.push(loginPage);
    } else {
      setUserTokken(tokken);
    }
  }, []);
  useEffect(() => {
    if (userTokken) {
      searchApplications();
      getUserStatus();
    }
  }, [userTokken, page]);
  useEffect(() => {
    getAppStatus({
      available: totalApplicants,
      existing: applicationTotalCount
    });
  }, [applicationTotalCount, totalApplicants]);
  return /*#__PURE__*/React.createElement("div", {
    className: `dashboard-table ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, isLoading ? /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center py-5 mt-5 dashboard-loader"
  }, /*#__PURE__*/React.createElement(Loader, {
    className: "dashboard-spinner"
  })) : authFailed ? /*#__PURE__*/React.createElement("b", {
    className: "auth-failed"
  }, authFailed) : applicationList.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table__header d-none d-md-flex row"
  }, DashboardTableHeader.map((item, index) => /*#__PURE__*/React.createElement("div", {
    className: `dashboard-table__header-item col col-${index === 1 || index === 4 ? 3 : 2}`,
    key: index
  }, /*#__PURE__*/React.createElement("span", null, item)))), /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table__body"
  }, applicationList.map((item, index) => /*#__PURE__*/React.createElement(DashboardTableItem, {
    key: index + '_' + (item.ApplicationNo || ''),
    item: item,
    labels: DashboardTableHeader,
    dictionary: dictionary,
    settings: settings,
    configuration: configuration
  }))), applicationTotalCount > applicationList.length && /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table__pagination"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: loadMore,
    className: "btn btn-secondary"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: isLoadingMore ? 0 : 1
    }
  }, getDictionaryItem(dictionary, 'loadMoreButton')), isLoadingMore ? /*#__PURE__*/React.createElement(Loader, {
    className: "dashboard-spinner"
  }) : false))) : /*#__PURE__*/React.createElement(DashboardEmpty, null, /*#__PURE__*/React.createElement(InjectHTML, {
    htmlString: getDictionaryItem(dictionary, 'notApplicationsFound')
  })));
};
export default DashboardTable;
const commonStyles = "c3hhrv9";
const ltrStyles = "l11hsb5x";
const rtlStyles = "re9f7bv";